import { FeatureToggleName } from '~api/model/unleash';

import { useFeatureToggles } from '~modules/featureToggles';

export const useIsFeatureActive = (feature: FeatureToggleName): boolean => {
    const featureToggles = useFeatureToggles();

    return featureToggles.enabledFeatures.some(featureToggle => featureToggle === feature);
};
